import * as React from 'react';
import axios from 'axios';
import { Marquage } from './iMonCompte';
import { getBoutiqueColor, getUserId } from './MonCompteAction';
import { renderAlert } from './RenderCommon';
import Icons from './Icons';
import Modal from 'react-responsive-modal';
import { RenderPicto } from './RenderPicto';
import {getHostApi, getRequestConfig} from '../../utils';

// @ts-ignore
import ReactTooltip from 'react-tooltip';
import {getShopInfosInStorage} from "../cart/ShopInfos";

export class RenderArticleConcerne extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      openModalPanachage: false,
      qtePanachage: '0',
      showAlert: false,
      textAlert: '',
      classAlert: '',
    };
  }

  _createFormData = () => {
    const formData = new FormData();

    if (this.state.creationIdSelected && this.state.creationIdSelected !== '0'
      && this.state.creationIdSelected !== 'new') {
      formData.append('creation_id', this.state.creationIdSelected);
    }

    return formData;
  }

  _sendOrder = () => {
    if (this.props.onOrderUpdated) { this.props.onOrderUpdated(); }
  }

  _modifyCartLine = () => {
    const quantite = Number(this.props.panier.Quantite) - Number(this.state.qtePanachage);

    if (quantite > 0) {
      const formData = this._createFormData();
      formData.append('quantite', String(quantite));
      const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.orderId}/items/${this.props.panier.idCaddies}`;
      axios.post(url, formData,
        getRequestConfig(),
      ).then((response) => {
        if (response.data.cartLine) {
          this._sendOrder();
          this.setState({
            creationIdSelected: undefined
          });
        }
      }).catch((error) => {
        console.log('error');
      });
    } else {
      this._setPanachage(1);
    }
  }

  _splitCart = () => {
    if (this.state.qtePanachage !== '0') {
      if (!this.defineIfPanachageForMarquage() || (this.defineIfPanachageForMarquage() &&
        this.state.creationIdSelected && this.state.creationIdSelected !== '0')) {
        this.setState({ openModalPanachage: false }, () => { this._modifyCartLine(); });
      } else {
        this.setState({
          showAlert: true,
          textAlert: 'Veuillez sélectionner un panachage',
          classAlert: 'alert-danger',
        });
      }
    } else {
      this.setState({
        showAlert: true,
        textAlert: 'Veuillez préciser une quantité à panacher',
        classAlert: 'alert-danger',
      });
    }
  }

  _setPanachage = (value: number = 0) => {
    const creationId = this._defineCreationIdToSend(value);

    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.orderId}/items/${this.props.panier.idCaddies}`;
    axios.put(url, {
        value: value, creationId: creationId,
        emplacementId: this.props.emplacement.id, surfaceId: this.props.surface.id,
      },
      getRequestConfig(),
    ).then((response) => {
      this._sendOrder();
      this.onCloseModalPanachage();
    }).catch((error) => {
      console.log('error');
    });
  }

  showHideTooltip = (identifier: string) => {
    const tooltip = document.getElementById(identifier);

    if (tooltip) {
      if (tooltip.style.display === 'none') {
        tooltip.style.display = 'block';
      } else {
        tooltip.style.display = 'none';
      }
    }
  }

  defineSrcImage = (links: any) => {
    let src = '';
    if(links && links.images['50x50'] && links.images['50x50'][0]) {
        src = links.images['50x50'][0];
      }
    else if(links && links.images_principales && links.images_principales['50x50'] ) {
        src = links.images_principales['50x50'];
    }
    else if (links && links.images && links.images['50x50'] && links.images['50x50'][1] && links.images['50x50'][1].lien ) {
      src = links.images['50x50'][1].lien;

      if (links.images['128x128']) {
        src = links.images['128x128'][1].lien;
      } else if (links.images['270x270']) {
        src = links.images['270x270'][1].lien;
      } else if (links.images['200x300']) {
        src = links.images['200x300'][1].lien;
      } else if (links.images['550x550']) {
        src = links.images['550x550'][1].lien;
      }
    } else if (links.images_principales && links.images_principales['50x50'] && links.images_principales['50x50'].lien) {
      src = links.images_principales['50x50'].lien;

      if (links.images_principales['128x128']) {
        src = links.images_principales['128x128'].lien;
      } else if (links.images_principales['270x270']) {
        src = links.images_principales['270x270'].lien;
      } else if (links.images_principales['200x300']) {
        src = links.images_principales['200x300'].lien;
      } else if (links.images_principales['550x550']) {
        src = links.images_principales['550x550'].lien;
      }
    }
    return src;
  }

  onOpenCancelModalPanachage = () => {
    this.setState({ openCancelModalPanachage: true });
  }

  onOpenModalPanachage = () => {
    this.setState({ openModalPanachage: true });
  }

  onCloseModalPanachage = () => {
    this.setState({ openModalPanachage: false, openCancelModalPanachage: false });
  }

  _onUpdateInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ qtePanachage: event.target.value });
  }

  _onChangePanachage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    if (value !== '0') { this.setState({ creationIdSelected: value }); }
  }

  defineIfPanachageForMarquage = () => {
    if (this.props.nbPanachages.length > 0) {
      for (const nbPanachage of this.props.nbPanachages) {
        if (nbPanachage.marquage === this.props.marquage.nom) { return true; }
      }
    }
    return false;
  }

  _defineCreationIdToSend(value: number) {
    if (value === 0) {
      for (const panier of this.props.paniers) {
        if (panier.panachage === '0' && panier.marquage === this.props.marquage.nom &&
          panier.article.produit.picto.nom === this.props.pictogramme.nom &&
          panier.article.couleur.cmjn.cyan == this.props.color.cmjn.cyan &&
          panier.article.couleur.cmjn.magenta == this.props.color.cmjn.magenta &&
          panier.article.couleur.cmjn.jaune == this.props.color.cmjn.jaune &&
          panier.article.couleur.cmjn.noir == this.props.color.cmjn.noir) {
          for (const marquagePanier of panier.marquages) {
            if (marquagePanier.emplacement === this.props.emplacement.nom &&
              marquagePanier.surface === this.props.surface.nom) {
              return panier.creation_id;
            }
          }
        }
      }
    } else if (this.state.creationIdSelected !== 'new') { return this.state.creationIdSelected; }

    return null;
  }

  _defineIfPanachageIsAvailable = () => {
    for (const nbPanachage of this.props.nbPanachages) {
      if (nbPanachage.marquage === this.props.marquage.nom &&
        parseInt(nbPanachage.nbPanachages) < parseInt(nbPanachage.nbPanachagesAutorises)) {
        return true;
      }
    }
    return false;
  }

  _checkCorrespondanceBetweenArticleAndDataPanachage = () => {
    for (const nbPanachage of this.props.nbPanachages) {
      if (nbPanachage.marquage === this.props.marquage.nom) {
        if (nbPanachage.datas) {
          for (const data of nbPanachage.datas) {
            if (data.picto === this.props.pictogramme.nom &&
              data.color.cmjn.cyan == this.props.color.cmjn.cyan &&
              data.color.cmjn.magenta == this.props.color.cmjn.magenta &&
              data.color.cmjn.jaune == this.props.color.cmjn.jaune &&
              data.color.cmjn.noir == this.props.color.cmjn.noir) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  _defineCurentSurface = (marquage: Marquage) => {
    if (this.props.surface.nom === marquage.surface && this.props.emplacement.nom === marquage.emplacement) {
      return 'bold black';
    }

    return '';
  }

  _defineBoostrapClassToSurfaces = () => {
    if (this.props.panier.panachage === '1') { return 'col-md-5'; }

    if (!this.props.activatePanachage || !this.props.selectPanachage) {
      return 'col-md-10';
    }

    return 'col-md-7';
  }

  _defineActivatePanachageToTest = () => {
    if (this.props.marquage.libelle === 'Quadriluxe') {
      return this.props.activatePanachageQuadriluxe;
    }
    if (this.props.marquage.libelle === 'TopQuadri') {
      return this.props.activatePanachageTopQuadri;
    }
    if (this.props.marquage.libelle === 'SeriCoat') {
      return this.props.activatePanachageSericoat;
    }
    if (this.props.marquage.libelle === 'Broderie') {
      return this.props.activatePanachageBroderie;
    }
    if (this.props.marquage.libelle === 'Sublimation') {
      return this.props.activatePanachageSublimation;
    }
  }

  render() {
    const renderImgageProduit = (width: number) => {
      let blackAndWhiteImg = '';
      if (this.props.panier.article.links.images.length === 0) { blackAndWhiteImg = 'imgBW'; }

      return (
        <div className="col-md-1 p-0 col-2">
          <img className={blackAndWhiteImg} src={this.defineSrcImage(this.props.panier.article.links)} width={width} />
        </div>
      );
    };

    const renderTitreProduit = () => {
      const codeCouleur1 = '#' + this.props.panier.article.couleur.code1;

      return (
        <div className="font14">
          {this.props.panier.article.produit.Titre}&nbsp;
          {getShopInfosInStorage().Ref != 'DT' &&
          <>
          {this.props.panier.article.produit.reference_visible}
          &nbsp;-&nbsp;
          <Icons icon="circle" size={15} color={codeCouleur1} /> {this.props.panier.article.couleur.Couleur}
          </>
          }
        </div>
      );
    };

    const renderQuantiteTailleProduit = () => {
      return (
        <div className="col-md-8 col-4 p-0">
          <div className="bold">Quantité : {this.props.panier.Quantite}</div>
          <div className="bold">Taille : {this.props.panier.taille}</div>
          <div className="d-none">
            <div className="bold">Panier : {this.props.panier.idCaddies}</div>
            <div className="bold">Création : {this.props.panier.creation_id}</div>
          </div>
        </div>
      );
    };

    const renderTooltip = (texte: string, error: boolean = false) => {
      let left = '112px';
      let shadow = '';

      if (this.props.panier.panachage === '1') { left = '192px'; }

      if (error) { shadow = '0px 0px 4px 1px indianred'; }

      return (
        <div id={'tooltip-' + this.props.panier.idCaddies + '-' + this.props.identifier}
             className="position-absolute pa1 bg-black white display-mobile-none"
             style={{ display: 'none', left: left, width: 'max-content', zIndex: 1, boxShadow: shadow }}>
          <span className="position-absolute" style={{
            width: '0', top: '11px', height: '10px', left: '-15px',
            border: '8px solid transparent', borderRight: '15px solid #3d3c3f',
          }}>&nbsp;</span>
          <div>{texte}</div>
        </div>
      );
    };

    /*const renderGuide = () => {
      return (
        <div className="bg-black white ml-2 text-center font14 p-1 bold cursor-pointer"
             style={{ borderRadius: '50%', width: '31px' }}>
          i
        </div>
      );
    };*/

    const renderTitreCouleurProduitModal = () => {
      return (
        <div className="d-flex align-items-center">
          <span className="bold">{this.props.panier.article.produit.Titre}</span><span>&nbsp;-&nbsp;</span>
          <div>
            <Icons icon="circle" size={25} color={'#' + this.props.panier.article.couleur.code1} />
            &nbsp;{this.props.panier.article.couleur.Couleur}
          </div>
        </div>
      );
    };

    const renderPictosModal = () => {
      const html = [];
      for (const surface of this.props.surfacesEmplacements[0]) {
        for (const emplacement of this.props.surfacesEmplacements[1]) {
          for (const marquage of this.props.panier.marquages) {
            if (marquage.surface === surface.nom && marquage.emplacement === emplacement.nom) {
              html.push(
                <div style={{width: "60px"}} className="mr-2 text-center" key={surface.id + '-' + emplacement.id + '-' +
                marquage.surface + '-' + marquage.emplacement}>
                  <RenderPicto picto={this.props.pictogramme} surface={surface} emplacement={emplacement}
                               id={this.props.panier.idCaddies} cartId={this.props.panier.idCaddies}
                               orderId={this.props.orderId} numCommande={this.props.numCommande}
                               color={this.props.panier.article.couleur} />
                  <div className="">{marquage.surface} {marquage.emplacement} </div>
                </div>,
              );
            }
          }
        }
      }

      return (<div className="d-flex pictoModal">{html}</div>);
    };

    const renderTailleQuantiteModal = () => {
      return (
        <div className="tailleQuantiteModal p-3 bg-grey2 bold">
          <div className="d-flex flex-column justify-content-center h-100 tailleQuantiteModalContent">
            <div>Taille : {this.props.panier.taille}</div>
            <div>Quantité : {this.props.panier.Quantite}</div>
          </div>
        </div>
      );
    };

    const renderInfosProduitModal = () => {
      return (
        <div className="d-flex align-items-center border mt-1 justify-content-between infosProduitModal">
          <div className="align-self-stretch">
            <div className="d-flex flex-column justify-content-center bg-grey2 p-3 imgInfosProduitModal">
              {renderImgageProduit(60)}
              {renderTitreCouleurProduitModal()}
            </div>
          </div>
          {renderPictosModal()}
          {renderTailleQuantiteModal()}
        </div>
      );
    };

    const renderInputModal = () => {
      return (
        <div className="text-center d-flex qteAPanacher flex-column mt-3">
          <div className="very-small">Quantité à panacher :</div>
          <div className="inputModalePanachage">
            <input type="number" max={this.props.panier.Quantite} min={0} onChange={e => this._onUpdateInput(e)}
                   name={'qtePanachage' + this.props.panier.idCaddies}
                   value={this.state.qtePanachage} />&nbsp;/&nbsp;{this.props.panier.Quantite}
          </div>
        </div>
      );
    };

    const renderButtonModal = (onClick: any) => {
      return (
        <div className="text-center mt-3">
          <button title="Valider"
                  className="btnValiderPanachage cursor-pointer btnValidateModal py-2 px-5 big white border-0"
                  onClick={() => { onClick(); }} style={{ background: getBoutiqueColor() }}>
            Valider
          </button>
        </div>
      );
    };

    const isEqual = (a: number | null, b: number | null): boolean => {
      return a === b || (a === null && b === 0) || (a === 0 && b === null);
    };

    const renderOptionsSelectPanachage = () => {
      const tabOptions = [];

      tabOptions.push(
        <option key="panachage-0" className="grey font11" value="0">Sélectionnez un panachage...</option>,
      );

      for (const nbPanachage of this.props.nbPanachages) {
        if (nbPanachage.marquage === this.props.marquage.nom) {
          if (nbPanachage.datas) {
            for (const data of nbPanachage.datas) {
              if (data.picto === this.props.pictogramme.nom &&
                isEqual(data.color.cmjn.cyan, this.props.color.cmjn.cyan) &&
                isEqual(data.color.cmjn.magenta,this.props.color.cmjn.magenta) &&
                isEqual(data.color.cmjn.jaune, this.props.color.cmjn.jaune) &&
                isEqual(data.color.cmjn.noir, this.props.color.cmjn.noir)) {
                tabOptions.push(
                  <option value={data.creation_id} key={'panachage-' + data.creation_id}>
                    Panachage {this.props.marquage.libelle} n°{data.numeroBloc}
                  </option>,
                );
              }
            }
          }
        }
      }

      if (this._defineIfPanachageIsAvailable()) {
        tabOptions.push(<option value="new" key="panachage-new">Créer un nouveau panachage</option>);
      }

      return tabOptions;
    };

    const renderSelectPanachage = () => {
      if (this.props.nbPanachages.length > 0) {
        if (this.defineIfPanachageForMarquage()) {
          return (
            <select className="w-50 mx-auto text-uppercase selectPanachage" style={{ marginTop: '20px' }}
                    onChange={e => this._onChangePanachage(e)}>
              {renderOptionsSelectPanachage()}
            </select>
          );
        }
      }
    };

    const renderModalPanachage = () => {
      if(this.state.openModalPanachage) {
        return (
          <Modal animationDuration={0} open={this.state.openModalPanachage} onClose={this.onCloseModalPanachage} center
                 classNames={{
                   overlay: 'bootstrap-container',
                   modal: 'panachageModalContainer customModal',
                   closeButton: 'panachageModalCloseButton closeButton'
                 }}>
            <div className="modalPanacher p-2 pa0Mobile">
              <p className="border-bottom">Panachage des visuels</p>
              {renderAlert(this.state.showAlert, this.state.classAlert + ' justify-content-center', this.state.textAlert)}
              <div className="d-flex flex-column mt-4">
                {renderInfosProduitModal()}
                {renderInputModal()}
                {renderSelectPanachage()}
              </div>
              {renderButtonModal(this._splitCart)}
            </div>
          </Modal>
        );
      }
    };

    const renderModalCancelPanachage = () => {
      if(this.state.openCancelModalPanachage) {
        return (
          <Modal animationDuration={0} open={this.state.openCancelModalPanachage} onClose={this.onCloseModalPanachage}
                 center
                 classNames={{
                    overlay: 'bootstrap-container',
                   modal: 'cancelPanachageModalContainer customModal',
                   closeButton: 'cancelPanachageModalCloseButton closeButton'
                 }}>
            <div className="modalPanacher p-2 pa0Mobile">
              <p className="border-bottom">Panachage des visuels</p>
              <div className="d-flex flex-column mt-4">
                {renderTitreCouleurProduitModal()}
                {renderInfosProduitModal()}
                <p className="text-center bold mt-3">Etes-vous sûr de vouloir supprimer cette ligne du panachage ?</p>
              </div>
              {renderButtonModal(this._setPanachage)}
            </div>
          </Modal>
        );
      }
    };

    const renderCancelPanachageButton = (identifier: string) => {
      return (
        <div className="d-flex col-md-5 col-8 align-items-center px-2 position-relative">
          <button className="bg-transparent py-1 px-3 border-dark bold cursor-pointer btnSuppressionPanachage"
                  style={{ borderRadius: '20px', zIndex: 2 }} onMouseEnter={e => this.showHideTooltip(identifier)}
                  onMouseLeave={e => this.showHideTooltip(identifier)} onClick={this.onOpenCancelModalPanachage}>
            Retirer de ce panachage
          </button>
          {renderTooltip('Retirer cette ligne de ce panachage.')}
          {renderModalCancelPanachage()}
        </div>
      );
    };

    const renderAddPanachageButton = (identifier: string) => {
      let disabled = false;
      let opacity = 1;

      if (this.props.nbPanachages.length > 0 && !this._checkCorrespondanceBetweenArticleAndDataPanachage() &&
        !this._defineIfPanachageIsAvailable()) {
        disabled = true;
        opacity = 0.5;
      }

      if (this._defineActivatePanachageToTest()) {
        return (
          <div className="d-flex col-md-3 col-8 align-items-center px-2 position-relative btnAddPanachage">
            <button className="bg-transparent py-1 px-3 border-dark bold cursor-pointer" data-tip data-for="explainPanachage" html-for="activatePanachage"
                    style={{ borderRadius: '20px', width: '92px', opacity: opacity, zIndex: 2 }} disabled={disabled}
                    onClick={this.onOpenModalPanachage}>
              Panacher
            </button>
            {/*renderTooltip(texteTooltip, disabled)*/}
            <ReactTooltip id="explainPanachage" type="dark">
              <div style={{ maxWidth: '300px' }}>
                Le panachage vous permet d'importer des visuels différents par article.
              </div>
            </ReactTooltip>
            {/* renderGuide() */}
            {renderModalPanachage()}
          </div>
        );
      }

    };

    const renderButtons = () => {
      if (this.props.activatePanachage && this.props.selectPanachage && this.props.confirmationFichiers === 0) {
        const identifier = 'tooltip-' + this.props.panier.idCaddies + '-' + this.props.identifier;

        if (this.props.panier.panachage === 0) {
          return renderAddPanachageButton(identifier);
        }
        return renderCancelPanachageButton(identifier);
      }
    };

    const renderSurfaces = (marquages: Marquage[]) => {
      const html = [];
      let i = 1;

      for (const marquage of marquages) {
        html.push(
          <span className={this._defineCurentSurface(marquage)} key={marquage.surface + '-' + marquage.emplacement}>
            {marquage.surface} {marquage.emplacement}
          </span>,
        );

        if (i < marquages.length) { html.push(' / '); }

        i++;
      }

      return (
        <div>Surfaces : {html}</div>
      );
    };

    const renderMarquageSurfaces = () => {
      return (
        <div className={this._defineBoostrapClassToSurfaces() + ' text-right p-0 grey col-12'}>
          {this.props.activatePanachage && this.props.selectPanachage && this._defineActivatePanachageToTest() && (
            renderSurfaces(this.props.panier.marquages)
          )}
        </div>
      );
    };

    const renderInfosProduit = () => {
      return (
        <div className="d-flex align-items-center col-md-12 p-0 flex-wrap">
          {renderQuantiteTailleProduit()}
          {renderButtons()}
          {renderMarquageSurfaces()}
        </div>
      );
    };

    const renderArticleConcerne = () => {
      return (
        <div className="d-flex p-2 ligneDetailArticles align-items-center position-relative"
             style={{ borderBottom: '2px solid white' }}>
          {renderImgageProduit(60)}
          <div className="d-flex flex-column col-md-11 pr-0 col-10">
            {renderTitreProduit()}
            {renderInfosProduit()}
          </div>
        </div>
      );
    };

    return (
      <>
        {(this.props.identifier &&  this.props.color && this.props.pictogramme) && (
          <div
            className="divLigneDetailArticles"
            key={
              this.props.marquage.id + '-' + this.props.surface.id + '-' +
              this.props.emplacement.id + '-' + this.props.pictogramme.id + '-' +
              this.props.color.Couleur + '-' + this.props.panier.idCaddies
            }
          >
            {renderArticleConcerne()}
          </div>
        )}
      </>
    );
  }
}
